export default __webpack_public_path__ + "static/media/measure-total-body-weight-through-fitness-app.e9e087f3.png";